// Public company and bank-transfer details supplied by the merchant.
export const company = Object.freeze({
  name: 'KREATIVNE APLIKACIJE d.o.o. za trgovinu i usluge',
  street: 'Maksimirska cesta 94',
  postalCode: '10000',
  city: 'Zagreb',
  address: 'Maksimirska cesta 94, 10000 Zagreb',
  oib: '50180117560',
  email: 'info@kreativne-aplikacije.com',
  iban: 'HR6924840081135511953'
});